export const getPricingConfig = ($config) =>
  Object.freeze({
    PLUS_MONTH: {
      price: $config.plusMonthPriceAmount,
      idNL: $config.nldPlusMonthPrice,
      idEN: $config.engPlusMonthPrice
    },
    PLUS_YEAR: {
      price: $config.plusYearPriceAmount,
      idNL: $config.nldPlusYearPrice,
      idEN: $config.engPlusYearPrice
    },
    PREMIUM_MONTH: {
      price: $config.premiumMonthPriceAmount,
      idNL: $config.nldPremiumMonthPrice,
      idEN: $config.engPremiumMonthPrice
    },
    PREMIUM_YEAR: {
      price: $config.premiumYearPriceAmount,
      idNL: $config.nldPremiumYearPrice,
      idEN: $config.engPremiumYearPrice
    }
  })
